import { Col, Row } from 'antd';
import { Observer } from 'mobx-react';
import { Navigate } from 'react-router-dom';
import { useMainStore } from 'store/mobXStores/mainStore';
import LoginForm from './LoginForm';
import './login.css';

const Login = props => {
	const mainStore = useMainStore();
	const { loginStore } = mainStore;
	return (
		<Observer>
			{() => {
				const { isLoading, isLogInSuccess } = loginStore;
				if (!isLoading && isLogInSuccess) {
					return <Navigate to="/" replace={true} />;
				}
				return (
					<div className="modern-login-container">
						<div className="modern-login-background">
							<Row justify="center" align="middle" className="h-100">
								<Col xs={22} sm={20} md={16} lg={12} xl={10} xxl={8}>
									<div className="modern-login-card">
										<div className="modern-login-logo">
											<img src="/img/asepsis-logo.svg" alt="Asepsis Logo" />
										</div>
										<LoginForm {...props} />
									</div>
								</Col>
							</Row>
						</div>
					</div>
				);
			}}
		</Observer>
	);
};

export default Login;
